var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card stats-card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-5"},[_vm._t("header")],2),_c('div',{staticClass:"col-xs-7"},[_vm._t("content")],2)])]),_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }